module.exports = __webpack_public_path__ + "img/1-1.4803626a.svg";